import Collection from './collection.js';
import DefaultPayrollDetail from 'newModels/default-payroll-detail.js';

export default class DefaultPayrollDetails extends Collection {
    url() {
        if (this.employee) {
            return `${this.employee.url()}/defaultPayrollDetails`;
        }

        return `/DefaultPayrollDetails`;
    }

    initialize(models, {employee = null}) {
        super.initialize(...arguments);
        this.model = DefaultPayrollDetail;
        this.employee = employee;
        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/default-payroll-details.js